export enum MessageSenderType {
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
  LIVE_AGENT = 'LIVE_AGENT',
  SYSTEM = 'SYSTEM',
}
